/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useState, useEffect, useContext, useRef } from "react";
import { useHistory } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import * as yup from 'yup';

/* import { GlobalAuthContext, GlobalOperationContext } from 'store/context'; */

import { Row, Col } from "components/Grid";
import { Label } from "components/Form";
import Layout from "components/Layout/index";
import SubTitle from "components/SubTitle";
import ContentCard from "components/ContentCard";
import Button, { ButtonContainer, ButtonContent } from 'components/Button';
import TagInput from "components/TagInput";
import TagsList2 from "components/TagList2";
import BrokingSummary from "components/BrokingSummary";
import TextField from 'components/Form/TextField';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import CheckBox from "components/Form/CheckBox";
import InputField from "components/Form/InputField";
import DialogComponent from 'components/ModalCancel';


import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext, GlobalOperationContext } from 'store/context';
import { FitinsurAPI, MessageCenter } from 'utils';

import { Title, Text } from "./styles";
import StepNavigation from "components/StepNavigation/index";

export default function SendPaymentPackInsurerClient(props) {


  const [summary, setSummary] = useState({});
  const [paymentPackMessage, setPaymentPackMessage] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [attachmentsTag, setAttachmentsTag] = useState([]);
  const [userComments, setUserComments] = useState(null);
  const operationContext = useContext(GlobalOperationContext);
  const authContext = useContext(GlobalAuthContext);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItems2, setSelectedItems2] = useState([]);
  const [selectedExternalBrokers, setSelectedExternalBrokers] = useState([]);
  const [selectedThirdParties, setSelectedThirdParties] = useState([]);
  const [insurers, setInsurers] = useState([]);
  const [historymsg, setHistorymsg] = useState([]);
  const [client, setClient] = useState([]);
  const [externalBrokers, setExternalBrokers] = useState([]);
  const [thirdParties, setThirdParties] = useState([]);
  const [endorsmentType, setEndorsmentType] = useState("");
  const [dialog, setDialog] = useState({ visible: false });

  /* const [rejectDocuments, setRejectDocuments] = useState(false); */

  const formik = useRef(null);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const loading = useContext(GlobalLoaderContext);


  const validation = () => {
    //if(selectedItems.length <= 0 ||  selectedItems2.length <= 0 ||  selectedExternalBrokers.length <= 0 || selectedThirdParties.length <= 0 ){
    if (selectedItems.length <= 0 || selectedItems2.length <= 0) {
      return false;
    } else {
      return true;
    }
  }

  const goToLoginPage = () => {
    history.push('/login');
  };

  function handleSummary() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestHeaderNbi(props.match.params.idOperation)
      .then(response => response.json()).then(data => {
        console.log("Sumario-> ", data.ret_value)
        setSummary({
          typeOfCover: data.ret_value.typeOfCover,
          client: data.ret_value.client,
          obligorCoding: data.ret_value.obligorCoding,
          responseBy: data.ret_value.responseBy,
          internalContact: data.ret_value.internalContact,
          broker: data.ret_value.broker,
          dealCode: data.ret_value.deal,
          nmFacility: data.ret_value.nmFacility,
          nmObligor: data.ret_value.nmObligor,
          projectName: data.ret_value.projectName,
          idOperation: props.match.params.idOperation,
        });
        setHistorymsg(data.ret_value.historical);
        setEndorsmentType(data.ret_value.endorsmentType)
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostSummary - Error:', error);
      });
    loading.stop();
  };

  function handleSend() {
    let valid = validation();
    if (valid != true) {
      mc.error('Please fill in all required fields.');
      return
    }

    fitinsur.setAuthToken(authContext.token);
    let insuresContacts = [];

    insurers.forEach(x => {
      insuresContacts.push({
        idPersonInsurer: x.idPersonInsurer,
        contacts: []
      })
    })

    selectedItems.map(selectedInsurer => {
      let insurer = insuresContacts.find(e => e.idPersonInsurer == selectedInsurer.idPersonInsurer);
      insurer.contacts.push({ idContact: selectedInsurer.idContact, email: selectedInsurer.email });
    })

    let clientContacts = []
    selectedItems2.map(x => {
      clientContacts.push({ idContact: x.idContact, email: x.email });
    })


    let externalBrokersContacts = [];
    externalBrokers.map(x => {
      externalBrokersContacts.push({
        idPersonInsurer: x.idPersonInsurer,
        contacts: []
      })
    })

    selectedExternalBrokers.map(selectedInsurer => {
      let insurer = externalBrokersContacts.find(e => e.idPersonInsurer == selectedInsurer.idPersonInsurer);
      insurer.contacts.push({ idContact: selectedInsurer.idContact, email: selectedInsurer.email });
    })

    let thirdPartyContacts = [];
    thirdParties.map(x => {
      thirdPartyContacts.push({
        idPersonInsurer: x.idPersonInsurer,
        contacts: []
      })
    })

    selectedThirdParties.map(selectedInsurer => {
      let insurer = thirdPartyContacts.find(e => e.idPersonInsurer == selectedInsurer.idPersonInsurer);
      insurer.contacts.push({ idContact: selectedInsurer.idContact, email: selectedInsurer.email });
    })

    let body = {
      idOperation: props.match.params.idOperation,
      paymentPackMessage: formik.current.values.paymentPackMessage,
      insurers: insuresContacts,
      client: clientContacts,
      externalBrokers: externalBrokersContacts,
      thirdPartys: thirdPartyContacts
    };

    fitinsur.requestSendPaymantPackToInsurerAndClient(body)
      .then(resp => resp.json())
      .then(data => {
        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }
        history.push(`/list`);
      })
      .catch((error) => {
        mc.error("Erro executando consulta\n" + error);
        console.error('fitPostReject - Error:', error);
      });
  }


  function handleSelectInsurer(e, insurer) {
    const contact = { idPersonInsurer: insurer.idPersonInsurer, idContact: e.idContact, email: e.email };

    const alreadySelected = selectedItems.findIndex((item) => item.email === contact.email);
    if (alreadySelected >= 0) {
      const filteredItems = selectedItems.filter((item) => item.email !== contact.email);
      setSelectedItems(filteredItems);
    } else {
      let list = [...selectedItems];
      list.push(contact);
      setSelectedItems([...list]);
      console.log("list de contactos", selectedItems);
    };
  };

  function handleSelectExternalBroker(e, insurer) {
    const contact = { idPersonInsurer: insurer.idPersonInsurer, idContact: e.idContact, email: e.email };

    const alreadySelected = selectedExternalBrokers.findIndex((item) => item.email === contact.email);
    if (alreadySelected >= 0) {
      const filteredItems = selectedExternalBrokers.filter((item) => item.email !== contact.email);
      setSelectedExternalBrokers(filteredItems);
    } else {
      let list = [...selectedExternalBrokers];
      list.push(contact);
      setSelectedExternalBrokers([...list]);
      console.log("list de contactos", selectedExternalBrokers);
    };
  };

  function handleSelectClient(e) {
    const contact = { idContact: e.idContact, email: e.email };

    const alreadySelected = selectedItems2.findIndex((item) => item.email === contact.email);
    if (alreadySelected >= 0) {
      const filteredItems = selectedItems2.filter((item) => item.email !== contact.email);
      setSelectedItems2(filteredItems);
    } else {
      console.log(selectedItems)
      let list = [...selectedItems2];
      list.push(contact);
      setSelectedItems2([...list]);
    };
  };

  function handleSelectThirdParty(e, insurer) {
    const contact = { idPersonInsurer: insurer.idPersonInsurer, idContact: e.idContact, email: e.email };

    const alreadySelected = selectedThirdParties.findIndex((item) => item.email === contact.email);
    if (alreadySelected >= 0) {
      const filteredItems = selectedThirdParties.filter((item) => item.email !== contact.email);
      setSelectedThirdParties(filteredItems);
    } else {
      let list = [...selectedThirdParties];
      list.push(contact);
      setSelectedThirdParties([...list]);
      console.log("list de contactos", selectedThirdParties);
    };
  };

  function listContacts() {
    loading.start();
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestInsurerContacts(props.match.params.idOperationRoot || props.match.params.idOperation)
      .then(response => response.json())
      .then(data => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          loading.stop();
          return;
        }
        if (data.ret_value.length >= 1) {
          setInsurers(data.ret_value);
        }
      })
      .catch((error) => {
        mc.error("There was an error processing your request. Please try again later");
        console.error('fitPostListContact - Error:', error);
      });
    loading.stop();
  };

  function listContactsClients() {
    fitinsur.setAuthToken(authContext.token);

    fitinsur.listClientContacts(props.match.params.idOperationRoot || props.match.params.idOperation)
      .then(response => response.json())
      .then(data => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          return;
        }
        if (data.ret_value.length >= 1) {
          setClient(data.ret_value);
        }
      })
      .catch((error) => {
        mc.error("There was an error processing your request. Please try again later");
        console.error('fitPostListContact - Error:', error);
      });
  };


  function listExternalContacts() {
    fitinsur.setAuthToken(authContext.token);

    fitinsur.requestExternalContacts(props.match.params.idOperation)
      .then(response => response.json())
      .then(data => {
        if (data.ret_code != 200) {
          mc.error(data.ret_msg_details);
          history.goBack();
          loading.stop();
          return;
        }
        if (data.ret_value && (data.ret_value.externalBrokers || data.ret_value.thirdParties)) {
          setExternalBrokers(data.ret_value.externalBrokers);
          setThirdParties(data.ret_value.thirdParties);
        }
      })
      .catch((error) => {
        mc.error("There was an error processing your request. Please try again later");
        console.error('fitPostListContact - Error:', error);
      });
  };

  const renderExternalBrokerList = externalBrokers.map((externalBroker) => (
    <>
      <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
        <Title>
          {externalBroker.nmInsurer}
        </Title>
      </Row>

      {externalBroker.contacts.map((contact) => (
        <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px" }}>
          <Col style={{ flexDirection: "row", display: "flex" }}>
            <label>
              <CheckBox
                onChange={() => { handleSelectExternalBroker(contact, externalBroker) }}
                checked={selectedExternalBrokers.find((item) => item.email === contact.email) ? true : false}
              />
            </label>
            <Label>
              {contact.name}
            </Label>
          </Col>
          <Col md={8} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
            <Label>{contact.email}</Label>
          </Col>
        </Row>
      ))
      }
    </>
  ));

  const renderThirdParty = thirdParties.map((thirdParties) => (
    <>
      <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
        <Title>
          {thirdParties.nmInsurer}
        </Title>
      </Row>

      {thirdParties.contacts.map((contact) => (
        <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px" }}>
          <Col style={{ flexDirection: "row", display: "flex" }}>
            <label>
              <CheckBox
                onChange={() => { handleSelectThirdParty(contact, thirdParties) }}
                checked={selectedThirdParties.find((item) => item.email === contact.email) ? true : false}
              />
            </label>
            <Label>
              {contact.name}
            </Label>
          </Col>
          <Col md={8} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
            <Label>{contact.email}</Label>
          </Col>
        </Row>
      ))
      }
    </>
  ));

  const listItems = insurers.map((insurer) => (
    <>
      <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
        <Title>
          {insurer.insurerFirstName}
        </Title>
      </Row>

      {insurer.contacts.map((contact) => (
        <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px" }}>
          <Col style={{ flexDirection: "row", display: "flex" }}>
            <label>
              <CheckBox
                onChange={() => { handleSelectInsurer(contact, insurer) }}
                checked={selectedItems.find((item) => item.email === contact.email) ? true : false}
              /* disabled={contact?.existContact ? true : false} */
              />
            </label>
            <Label /* textColor={ contact?.existContact ? Colors.GRAY[3] : null} */>
              {contact.nameContact}
            </Label>
          </Col>
          <Col md={8} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
            <Label /* textColor={ contact?.existContact ? Colors.GRAY[3] : null} */>{contact.email}</Label>
          </Col>
        </Row>
      ))
      }
    </>
  ));

  const listItems2 = client.map((client) => (
    <>
      <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px", marginBottom: '5px' }}>
        <Col style={{ flexDirection: "row", display: "flex" }}>
          <label>
            <CheckBox
              onChange={() => { handleSelectClient(client) }}
              checked={selectedItems2.find((item) => item.email === client.email) ? true : false}
              disabled={client.existContact ? true : false}
            />
          </label>
          <Label>
            {client.nameContact}
          </Label>
        </Col>
        <Col md={8} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
          <Label>{client.email}</Label>
        </Col>
      </Row>
    </>
  ));

  useEffect(() => {
    loading.start();
    if (authContext.status !== true) {
      mc.error("Usuário não autenticado");
      loading.stop();
      goToLoginPage();
      return;
    } else {
      fitinsur.setAuthToken(authContext.token);
      loading.stop();
    };

    handleSummary();
    listContacts();
    listContactsClients();
    listExternalContacts()
  }, [])

  function handleDialog() {
    setDialog({ visible: true })
  }


  return (
    <Layout
      idOperation={props.match?.params?.idOperation}
      title={summary.projectName ? summary.projectName : summary.nmObligor ? summary.nmObligor : "Broking name"}
      subtitle={summary.dealCode ? summary.dealCode : "Broking code"}
    >
        <StepNavigation stage={2} idOperation={props.match?.params?.idOperation} /> 
      <BrokingSummary data={summary} />

      <ContentCard title={endorsmentType ? 'ANNIVERSARY: PREMIUM NOT PRE AGREED / SEND PAYMENT PACK' : "Send Payment Pack"} icon info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>

        <DialogComponent history={history} show={dialog.visible} setDialog={setDialog} idOperation={props.match?.params?.idOperation} />

        <Formik
          innerRef={formik}
          initialValues={{ paymentPackMessage: '' }}
          onSubmit={handleSend}
        >
          {formikProps => (
            <Form>
              <>
                <Title>TO - CLIENT</Title>
                {listItems2}
              </>
              <br></br>
              <>
                <Title>TO - INSURERS</Title>
                {listItems}
              </>
              <br></br>
              <>
                <Title>TO - EXTERNAL BROKER</Title>
                {renderExternalBrokerList}
              </>
              <br></br>
              <>
                <Title>TO - 3rd PARTY</Title>
                {renderThirdParty}
              </>
              <Field
                label={'Payment Pack Message'}
                name={'paymentPackMessage'}
                value={formikProps.values.paymentPackMessage}
                onChange={(e) => formikProps?.setFieldValue('paymentPackMessage', e)}
                component={TextField}
              />

              <ButtonContainer>
                <Button forth onClick={() => history.goBack()}>&lt; Back</Button>
                <ButtonContent>
                  <>
                    {endorsmentType ?
                      <Button
                        secundary
                        id="btnSubmitReject"
                        type="button"
                        onClick={e => handleDialog()}
                      >
                        CANCEL
                      </Button>
                      : null
                    }
                    <Button
                      style={{ marginLeft: "30px" }}
                      primary
                      type="submit"
                      id="btnSubmit"
                    >
                      SEND PAYMENT PACK
                      </Button>
                  </>
                </ButtonContent>
              </ButtonContainer>
            </Form>
          )}
        </Formik>
      </ContentCard>
      {loading.active && (<Loader backdropColor={Colors.WHITE} fullScreen />)}
    </Layout>
  );
}